import React, { useContext } from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import MuiDialog from '../../../SystemDesign/MuiDialog';
import { useDeleteRaterTypeMutation } from '../../../services/SkillsManagement';
import { SnackBarContext } from '../../../Context/SnackBarContextProvider';
import { useDispatch } from 'react-redux';
import { DELETE_RATER_TYPE } from '../../../Reducers/Actions';

// Props: { row, onDeleted }
// - row: React Table row, expects row.original to be the rater type object { id, name, ... }
// - onDeleted?: optional callback invoked after successful deletion
const DeleteRaterType = ({ row, onDeleted }) => {
  const raterType = row?.original || {};
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);
  const [deleteRaterType] = useDeleteRaterTypeMutation();
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      await deleteRaterType({ id: String(raterType.id) }).unwrap();
      dispatch({ type: DELETE_RATER_TYPE, id: raterType.id });
      setInfoAlert({ severity: 'success', message: `Rater type "${raterType.name}" deleted successfully` });
      setOpenSnackBar(true);
      if (typeof onDeleted === 'function') onDeleted(raterType.id);
    } catch (error) {
      setInfoAlert({ severity: 'error', message: error?.data?.message || `Failed to delete rater type "${raterType.name}"` });
      setOpenSnackBar(true);
    }
  };

  const triggerButton = (
    <MenuItem>
      <ListItemIcon>
        <DeleteOutlineIcon fontSize="small" color="error" />
      </ListItemIcon>
      <ListItemText>Delete</ListItemText>
    </MenuItem>
  );

  const dialogContent = (
    <div>
      <p>Are you sure you want to delete the rater type "{raterType.name}"?</p>
      <p>This action is irreversible.</p>
    </div>
  );

  return (
    <MuiDialog
      icon={<DeleteOutlineIcon />}
      triggerButton={triggerButton}
      title="Delete Rater Type"
      subtitle={`You are about to delete ${raterType.name || 'this rater type'}`}
      content={dialogContent}
      existAction={true}
      actionTitle="Delete"
      actionFunction={handleDelete}
      actionType="button"
    />
  );
};

export default DeleteRaterType;
